import { useCallback, useEffect, useState } from 'react';

export interface WindowState {
  pinned: boolean;
  mini: boolean;
  canUninstall: boolean;
}
export interface WindowBridge {
  getState: () => Promise<WindowState | null>;
  setPinned: (on: boolean) => Promise<WindowState | null>;
  setMini: (on: boolean) => Promise<WindowState | null>;
}

export const windowBridge = (): WindowBridge | null => window.teaplus?.window ?? null;

export function useWindowControls() {
  const bridge = windowBridge();
  const [state, setState] = useState<WindowState | null>(null);
  useEffect(() => {
    if (bridge) void bridge.getState().then(setState);
  }, [bridge]);
  const setPinned = useCallback(
    async (on: boolean) => bridge && setState(await bridge.setPinned(on)),
    [bridge],
  );
  const setMini = useCallback(
    async (on: boolean) => bridge && setState(await bridge.setMini(on)),
    [bridge],
  );
  return bridge && state ? { ...state, setPinned, setMini } : null;
}
